import type { IconData } from '@stacksjs/iconify-core'

export const circleAndSquareShapeFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#2859c5\" d=\"M1.5 19.5c0 9.941 8.059 18 18 18s18-8.059 18-18s-8.059-18-18-18s-18 8.059-18 18\"/><path fill=\"#8fbffa\" d=\"M30.5 14.5c-4.46 0-7.682.139-9.907.297c-3.16.225-5.57 2.635-5.796 5.796c-.158 2.225-.297 5.447-.297 9.907s.139 7.682.297 9.907c.225 3.16 2.635 5.57 5.796 5.796c2.225.158 5.447.297 9.907.297s7.682-.139 9.907-.297c3.16-.226 5.57-2.636 5.796-5.796c.158-2.225.297-5.447.297-9.907s-.139-7.682-.297-9.907c-.226-3.16-2.636-5.57-5.796-5.796c-2.225-.158-5.447-.297-9.907-.297\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default circleAndSquareShapeFlat
